import Highcharts from 'utils/highcharts';
import { highchartsOptionsSetter } from 'utils/highchartsOptionsSetter';
import moment, { Moment, MomentInput } from 'moment-timezone';
import { LessonGroupProgressDTO } from '@peartherapeutics/hylia-api-client';
import modulesChartConfig from './chartConfig';

export interface ILessonChartProps {
  elementId: string;
  timezone: string;
  lessonGroups: LessonGroupProgressDTO[];
  allDays: number[];
  startDate: Nullable<Moment>;
  endDate: Nullable<Moment>;
}
export interface ISeries {
  name: string;
  className: string;
  data: { x: number; y: number }[];
}

export function getSeriesData(
  lessonGroups: LessonGroupProgressDTO[],
  allDays: number[],
  startDate: Nullable<Moment>,
  endDate: Nullable<Moment>,
  timezone: string,
) {
  return lessonGroups.map((lg) => ({
    type: 'column',
    name: lg.name,
    className:
      lg.name === 'Core Lessons' ? 'color-lifeSkills' : 'color-moodMatters',
    data: allDays.reduce((acc, indexDate) => {
      const lessonUsage = lg.lessonsUseByDate.find(
        (l) =>
          moment(l.date).tz(timezone).startOf('day').format('l') ===
          moment(indexDate).tz(timezone).startOf('day').format('l'),
      );

      if (
        startDate &&
        endDate &&
        moment(indexDate)
          .tz(timezone)
          .isBetween(
            startDate.tz(timezone).startOf('day'),
            endDate.tz(timezone).endOf('day'),
            undefined,
            '[]',
          )
      ) {
        if (lessonUsage?.date) {
          acc.push({
            x: lessonUsage.date,
            y: lessonUsage.totalTimeSpentMins,
          });
        } else if (acc.length) {
          acc.push({
            x: indexDate,
            y: 0,
          });
        }
      }
      return acc;
    }, [] as { x: number; y: number }[]),
  }));
}

export function fillDays(start: MomentInput, end: MomentInput) {
  const currentDateForLoop = moment(start).clone().startOf('day');
  const totalDays = Math.abs(
    Math.ceil(
      moment(end).clone().endOf('day').diff(currentDateForLoop, 'days', true),
    ),
  );
  return [...new Array(totalDays).keys()].reduce((acc: number[]) => {
    acc.push(currentDateForLoop.valueOf());
    currentDateForLoop.add(1, 'day');
    return acc;
  }, []);
}

export function drawLessonUsedChart({
  elementId,
  timezone,
  lessonGroups,
  allDays,
  startDate,
  endDate,
}: ILessonChartProps) {
  highchartsOptionsSetter(Highcharts);
  const config = {
    ...modulesChartConfig(elementId, timezone),
    series: getSeriesData(lessonGroups, allDays, startDate, endDate, timezone),
  };

  return new Highcharts.StockChart(config as any);
}
